<template>
  <div>
    <div class="row">
      <div class="col-12">
        <select-businesses-component
          ref="selectBusiness"
          :requiered="true"
          :initialData="businessesInitial"
          @onChange="updateSelectedBusinesses"
          @showHideLoading="showHideLoading"
        />
      </div>
      <div class="col-12 col-md-2 col-lg-2 col-xl-3">
        <div class="form-group has-label">
          <label>{{ $t('sigatoka.ages_to_evaluate') }}: *</label>
          <br />
          <el-select
            multiple
            clearable
            filterable
            collapse-tags
            class="select-primary custom-width-select shadow-sm required-ages"
            size="large"
            v-model="model.ages"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              class="select-primary"
              v-for="item in ages"
              :key="item.id + item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="col-12 col-md-2 col-lg-2 col-xl-3">
        <div class="form-group has-label d-flex flex-column align-items-center">
          <label>{{ $t('sigatoka.evaluate_young_plants') }}?</label>
          <br />
          <el-switch
            v-model="model.hasYoungPlants"
            :active-text="$t('common_words.yes')"
            :inactive-text="$t('common_words.no')"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
        </div>
      </div>
      <div class="col-12 col-md-2 col-lg-2 col-xl-3" v-if="this.isSuper()">
        <div class="form-group has-label d-flex flex-column align-items-center">
          <label>{{ $t('sigatoka.can_config_bw') }}?</label>
          <br />
          <el-switch
            v-model="model.canConfigBW"
            :active-text="$t('common_words.yes')"
            :inactive-text="$t('common_words.no')"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
        </div>
      </div>
      <div class="col-12 col-md-2 col-lg-2 col-xl-3" v-if="this.isSuper()">
        <div class="form-group has-label d-flex flex-column align-items-center">
          <label>{{ $t('sigatoka.change_label') }}?</label>
          <br />
          <el-switch
            v-model="model.changeLabel"
            :active-text="$t('common_words.yes')"
            :inactive-text="$t('common_words.no')"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
        </div>
      </div>
      <div
        class="col-12 col-md-2 col-lg-2 col-xl-4"
        v-if="model.hasYoungPlants"
      >
        <div class="form-group has-label">
          <label>{{ $t('sigatoka.young_leaves_to_evaluate') }}: *</label>
          <br />
          <el-select
            multiple
            clearable
            filterable
            collapse-tags
            class="select-primary custom-width-select shadow-sm required-leaves"
            size="large"
            v-model="model.young_leaves"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              class="select-primary"
              v-for="item in leaves"
              :key="item.id + item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isset } from 'src/util/Util';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations.js';
import Businesses from 'src/components/Selects/Businesses.vue';

export default {
  components: {
    [Businesses.name]: Businesses,
  },
  mixins: [
    MixinPermissions,
    MixinForm,
    MixinAlert,
    MixinLoading,
    MixinValidations,
  ],
  data() {
    return {
      businessesInitial: [],
      model: {
        ages: [],
        ages_ids: [],
        young_leaves: [],
        young_leaves_ids: [],
        canConfigBW: false,
        hasYoungPlants: false,
        changeLabel: false,
        businesses_id: [],
        businesses_names: [],
      },
    };
  },
  computed: {
    ages() {
      return [
        {
          id: '1',
          value: 0,
          label: this.$t('sigatoka.expecting'),
        },
        {
          id: '2',
          value: 1,
          label: this.$t('sigatoka.newly_given_birth'),
        },
        {
          id: '3',
          value: 2,
          label: '2 ' + this.$t('common_words.weeks'),
        },
        {
          id: '4',
          value: 3,
          label: '3 ' + this.$t('common_words.weeks'),
        },
        {
          id: '5',
          value: 4,
          label: '4 ' + this.$t('common_words.weeks'),
        },
        {
          id: '6',
          value: 5,
          label: '5 ' + this.$t('common_words.weeks'),
        },
        {
          id: '7',
          value: 6,
          label: this.model.changeLabel
            ? this.$t('sigatoka.young_6_weeks')
            : '6 ' + this.$t('common_words.weeks'),
        },
        {
          id: '8',
          value: 7,
          label: '7 ' + this.$t('common_words.weeks'),
        },
        {
          id: '9',
          value: 8,
          label: '8 ' + this.$t('common_words.weeks'),
        },
        {
          id: '10',
          value: 9,
          label: '9 ' + this.$t('common_words.weeks'),
        },
        {
          id: '11',
          value: 10,
          label: '10 ' + this.$t('common_words.weeks'),
        },
        {
          id: '12',
          value: 11,
          label: '11 ' + this.$t('common_words.weeks'),
        },
        {
          id: '13',
          value: 12,
          label: '12 ' + this.$t('common_words.weeks'),
        },
        {
          id: '14',
          value: 13,
          label: '13 ' + this.$t('common_words.weeks'),
        },
        {
          id: '15',
          value: 14,
          label: '14 ' + this.$t('common_words.weeks'),
        },
        {
          id: '16',
          value: 15,
          label: '15 ' + this.$t('common_words.weeks'),
        },
      ];
    },
    leaves() {
      return [
        { id: '1', value: 1, label: this.$t('sigatoka.leaf') + ' 1' },
        { id: '2', value: 2, label: this.$t('sigatoka.leaf') + ' 2' },
        { id: '3', value: 3, label: this.$t('sigatoka.leaf') + ' 3' },
        { id: '4', value: 4, label: this.$t('sigatoka.leaf') + ' 4' },
        { id: '5', value: 5, label: this.$t('sigatoka.leaf') + ' 5' },
        { id: '6', value: 6, label: this.$t('sigatoka.leaf') + ' 6' },
        { id: '7', value: 7, label: this.$t('sigatoka.leaf') + ' 7' },
        { id: '8', value: 8, label: this.$t('sigatoka.leaf') + ' 8' },
        { id: '9', value: 9, label: this.$t('sigatoka.leaf') + ' 9' },
        { id: '10', value: 10, label: this.$t('sigatoka.leaf') + ' 10' },
        { id: '11', value: 11, label: this.$t('sigatoka.leaf') + ' 11' },
        { id: '12', value: 12, label: this.$t('sigatoka.leaf') + ' 12' },
        { id: '13', value: 13, label: this.$t('sigatoka.leaf') + ' 13' },
        { id: '14', value: 14, label: this.$t('sigatoka.leaf') + ' 14' },
        { id: '15', value: 15, label: this.$t('sigatoka.leaf') + ' 15' },
        { id: '16', value: 16, label: this.$t('sigatoka.leaf') + ' 16' },
        { id: '17', value: 17, label: this.$t('sigatoka.leaf') + ' 17' },
        { id: '18', value: 18, label: this.$t('sigatoka.leaf') + ' 18' },
        { id: '19', value: 19, label: this.$t('sigatoka.leaf') + ' 19' },
        { id: '20', value: 20, label: this.$t('sigatoka.leaf') + ' 20' },
      ];
    },
  },
  methods: {
    updateSelectedBusinesses(data) {
      const bsSelected = data.associations_ids.concat(data.businesses_ids);
      this.$set(this.model, 'businesses_id', bsSelected);
      this.$set(this.model, 'businesses_names', data.names);
    },
    validate() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!isset(this.model.businesses_id))
            return this.validationInputsRequired('bus-rels');
          if (!isset(this.model.ages))
            return this.validationInputsRequired('ages');
          if (this.model.hasYoungPlants && !isset(this.model.young_leaves))
            return this.validationInputsRequired('leaves');
          this.$emit('on-validated', this.model);

          return isValid;
        }
      });
    },
  },
  mounted() {
    const editForm = JSON.parse(sessionStorage.getItem('editForm'));
    if (this.isUpdate() && editForm) {
      const ages = editForm.sigatoka_config_ages;
      const leaves = editForm.sigatoka_config_leaves;
      ages.forEach((value) => {
        this.model.ages.push(value.age);
        this.model.ages_ids.push(value.id);
      });
      leaves.forEach((value) => {
        this.model.young_leaves.push(value.leaf);
        this.model.young_leaves_ids.push(value.id);
      });
      this.model.hasYoungPlants = editForm.young_plant == 0 ? false : true;
      this.model.canConfigBW = editForm.config_bio_warning == 0 ? false : true;
      this.model.changeLabel = editForm.change_label == 0 ? false : true;
    }
  },
};
</script>
